import React from "react";
import { Link } from "react-router-dom";

export default function ProductCard({ product, onInquire }) {
  return (
    <div className="product-card bg-white rounded-md border border-gray-100 overflow-hidden flex flex-col">
      <Link to={`/products/${product.id}`} className="block aspect-[4/3] overflow-hidden bg-gray-50">
        <img src={product.image} alt={product.name} loading="lazy" className="w-full h-full object-cover zoom-img" />
      </Link>
      <div className="p-4 flex flex-col flex-1">
        <Link to={`/products/${product.id}`} className="text-[15px] font-bold text-brand-navy hover:text-brand-red transition-colors line-clamp-2 min-h-[44px]">
          {product.name}
        </Link>
        <p className="text-xs text-gray-500 mt-1">{product.category}</p>
        <p className="text-sm font-semibold text-brand-red mt-2">{product.price}</p>
        <button
          onClick={() => onInquire(product)}
          className="mt-3 btn-primary-brand text-xs font-semibold px-4 py-2.5 rounded-sm w-full"
        >
          Send Inquiry
        </button>
      </div>
    </div>
  );
}
